import React, { useState } from 'react';
import './ProjectsSection.css';
import './PublicationsSection.css';

const ProjectsSection = () => {
  const [activeFilter, setActiveFilter] = useState('all');
  
  const allItems = [
    {
      id: 'project-1',
      type: 'project',
      title: "Moodify: Emotion-Aware Music Recommendation",
      description: "A Flask app using YOLOv8 to detect emotions and recommend songs via KNN, SVD, and cosine similarity for a personalized listening experience.",
      category: "AI",
      tech: ["Python", "YOLOv8", "Flask", "KNN", "TruncatedSVD", "Cosine Similarity"],
      link: "https://github.com/vainavinair/YOLOv8-FER-MusicRecommendation"
    },
    {
      id: 'project-2',
      type: 'project',
      title: "Insecti-Sight: Insights and Classification Models for Insects in Southern States of India",
      description: "Analyzed millions of KCC records to predict pest outbreaks using text processing, SVD, and Bayesian-optimized models for accurate, real-time farming insights.",
      category: "ML",
      tech: ["Python", "XGBoost", "HashingVectorizer", "TruncatedSVD"],
      link: "#"
    },
    {
      id: 'project-3',
      type: 'project',
      title: "Flashcard Learning App",
      description: "A Flask-based app that generates flashcards using Gemini LLM and applies Bayesian spaced repetition for enhanced memory retention from uploaded notes.",
      category: "DL",
      tech: ["Python", "Flask", "Gemini (LLM)", "Bayesian Algorithms", "Spaced Repetition"],
      link: "https://github.com/vainavinair/FlashForge"
    },
    {
      id: 'publication-1',
      type: 'publication',
      year: 2024,
      title: "Music Recommender Based on the Facial Emotion of the User Identified Using YOLOV8",
      authors: "Vainavi Nair & Mahendra Kanojia",
      journal: "Intelligent Systems Design and Applications (ISDA2023)",
      abstract: "This paper explores novel neural network architectures for time series forecasting in renewable energy systems, demonstrating significant improvements in prediction accuracy.",
      link: "https://link.springer.com/chapter/10.1007/978-3-031-64836-6_23"
    },
    {
      id: 'publication-2',
      type: 'publication',
      year: 2023,
      title: "Integrating Facial Emotion Recognition into Music Recommendation Systems using YOLOv8.",
      authors: "Vainavi Nair & Mahendra Kanojia",
      journal: "Journal of Information Assurance & Security",
      abstract: "We present a framework for optimizing resource allocation in edge computing environments using reinforcement learning techniques, resulting in improved efficiency and latency.",
      link: "https://openurl.ebsco.com/EPDB%3Agcd%3A1%3A34456913/detailv2?sid=ebsco%3Aplink%3Ascholar&id=ebsco%3Agcd%3A177473737&crl=c&link_origin=scholar.google.com"
    }
  ];
  
  const filters = [
    { id: 'all', label: 'All' },
    { id: 'publication', label: 'Publications' },
    { id: 'ML', label: 'Machine Learning' },
    { id: 'AI', label: 'Artificial Intelligence' },
    { id: 'DL', label: 'Deep Learning' },
  ];
  
  const filteredProjects = activeFilter === 'all' 
    ? allItems 
    : activeFilter === 'publication'
    ? allItems.filter(item => item.type === 'publication')
    : allItems.filter(item => item.type === 'project' && item.category === activeFilter);
  
  return (
    <section id="projects" className="projects-section section">
      <div className="section-container">
        <h2 className="section-heading-main">Projects & Publications</h2>
      <div className="project-filters">
        {filters.map(filter => (
          <button 
            key={filter.id}
            className={`filter-btn ${activeFilter === filter.id ? 'active' : ''}`}
            onClick={() => setActiveFilter(filter.id)}
          >
            {filter.label}
          </button>
        ))}
      </div>
      
      <div className="projects-grid">
        {filteredProjects.map(item => (
          <a href={item.link} className={item.type === 'publication' ? 'publication-card-link' : 'project-card-link'} key={item.id}>
            <div className={item.type === 'publication' ? 'publication-card' : 'project-card'}>
              <h3 className={item.type === 'publication' ? 'publication-title' : 'project-title'}>{item.title}</h3>
              <div className={item.type === 'publication' ? 'publication-content' : 'project-content'}>
                <div className={item.type === 'publication' ? 'publication-info' : 'project-info'}>
                  {item.type === 'publication' ? (
                    <>
                      <p className="publication-meta">
                        <span className="publication-year">{item.year}</span> | <span className="publication-journal">{item.journal}</span>
                      </p>
                      <p className="publication-authors">{item.authors}</p>
                      <p className="publication-abstract">{item.abstract}</p>
                    </>
                  ) : (
                    <>
                      <p className="project-description">{item.description}</p>
                      <div className="project-tech">
                        {item.tech.map((tech, index) => (
                          <span className="tech-tag" key={index}>{tech}</span>
                        ))}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </a>
        ))}
      </div>
      
      <div className="projects-footer">
        <a href="https://github.com/vainavinair" className="btn">
          View More Projects
        </a>
        <a href="https://scholar.google.com/citations?user=Qzv7JaUAAAAJ&hl=en" className="btn">
          View All Publications
        </a>
      </div>
      </div>
    </section>
  );
};

export default ProjectsSection; 